import Header from "../../components/Header"
import { ContactForm } from "../../components/forms/ContactForm"
const ContactPage = () => {



    return (
        <>
        <ContactForm></ContactForm>
        </>
    )
}

export default ContactPage